import type { CollectionsTreeService } from '../services/CollectionsTreeService'
import type { NewNodePopoverResult } from './NewNodePopoverItems.tsx'
import type { CreateCollectionInput } from 'objects/gql/tree/CreateCollectionInput.ts'
import type { CreateFolderInput } from 'objects/gql/tree/CreateFolderInput.ts'
import type { SpacesService } from '@/spaces/services/SpacesService'
import type { CollectionViewsService } from '@/objects/services/CollectionViewsService.ts'

export class CollectionTreeController {
  constructor(
    private readonly collectionsService: CollectionsTreeService,
    private readonly spacesService: SpacesService,
    private readonly collectionViewsService: CollectionViewsService,
  ) {}

  // public prefetchCollectionData(collectionId: string): void {
  //   void this.collectionViewsService.fetchIfNotFetched(collectionId)
  // }

  public onNewNodePopoverItemClicked(
    { item, data }: NewNodePopoverResult,
    parentNodeId: string | null,
  ) {
    switch (item) {
      case 'Collection': {
        const input = {
          name: 'new-collection',
          typeId: data.objectTypeId,
          parentId: parentNodeId,
        } as CreateCollectionInput
        void this.collectionsService.createCollection(input)
        break
      }
      case 'Folder': {
        const input = {
          name: 'new-folder',
          spaceId: this.spacesService.selectedSpace$.value!.id,
          parentId: parentNodeId,
        } as CreateFolderInput
        void this.collectionsService.createFolder(input)
        break
      }
    }

    // focus node input to rename
  }
}
